import { OosSelectionContent } from "../components/OosSelectionContent";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { reset } from "../store";
export const OosSelection = ({ mode }: { mode?: "admin" | "viewer" }) => {
  const dispatch = useAppDispatch();
  // Reset Redux state when navigating to a new route/task
  useEffect(() => {
    // Cleanup function runs on component unmount
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  return <OosSelectionContent mode={mode} />;
};
